import { getEntityCountryCode } from '@rs-core/utils/healthCardNumberValidator';

const handleSSNChange = (event, onChange, resourceGroup) => {
	const inputValue = event.target.value;
	const entityCountryCode = getEntityCountryCode(resourceGroup);

	if (entityCountryCode === 'CA') {
		const replacedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
		onChange(replacedValue);
		return;
	}
	if (entityCountryCode === 'IN') {
		onChange(inputValue);
		return;
	}

	const digitsOnly = inputValue.replace(/\D/g, '');
	let formattedValue = '';
	if (digitsOnly.length >= 5) {
		formattedValue = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3, 5)}-${digitsOnly.slice(5, 9)}`;
	} else if (digitsOnly.length >= 3) {
		formattedValue = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
	} else {
		formattedValue = digitsOnly;
	}

	// Handle backspace key
	if (event.nativeEvent.inputType === 'deleteContentBackward') {
		if (inputValue.endsWith('-')) {
			formattedValue = formattedValue.slice(0, -1);
		}
	}
	onChange(formattedValue);
};

export default handleSSNChange;
